// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

const parallaxItems = [
  {
    container: '.news',
    target: '.news__svg',
    speed: 1
  },
  {
    container: '.events',
    target: '.events__svg',
    speed: -1
  }
];
  
const animate = () => {
  parallaxItems.forEach(({ container, target, speed }) => {
    const section = document.querySelector(container);
    const svg = section?.querySelector(target);

    if (!section || !svg) return;

    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // Progression normalisée (0 → 1)
    const progress = Math.min(
      Math.max((viewportHeight - rect.top) / (viewportHeight + rect.height), 0),
      1
    );

    svg.style.transform = `translateY(${progress * 100 * speed}px)`;
  });

  requestAnimationFrame(animate);
};

animate();

document.querySelectorAll('a[href="#"]').forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
  });
});
  
